import { Components, Theme } from '@mui/material/styles';

import { rootElement } from '../constants';

export const muiModalOverride: Components<Omit<Theme, 'components'>>['MuiModal'] = {
  defaultProps: {
    container: rootElement
  }
};
